import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter } from "react-router-dom";

import App from "./App";

(async () => {
  if (process.env.NODE_ENV === "development") {
    await import("bootstrap/dist/css/bootstrap.min.css");
    await import("./main.css");
  }
})();

const root = ReactDOM.createRoot(document.getElementById("react-block"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
